export default __webpack_public_path__ + "static/media/Instagram.64097936.svg";